import React from 'react';
//
import { TVisualContainerProps } from 'components/visuals/container';
import SurvivalPlot from 'components/visuals/survival/survival-plot';
import BoxPlot from 'components/visuals/box-plot/container';
import messages from 'constants/messages';
import MultiLineGraph from 'components/visuals/multi-line-graph/multi-line-graph';
import { EView } from 'components/deal-results/product-items';
import { NoDataContainer, Container, Visual, LineGraphContainer } from 'components/visuals/_common';

export default ({
  productSummary,
  periodStart,
  periodEnd,
  view,
  dealName,
  selectedCostFormulaLabel,
  selectedForecastLabel,
  pricePerUnitLabel,
  productItemId,
}: TVisualContainerProps) => {
  function renderContent() {
    if (!periodStart || !periodEnd) {
      return <NoDataContainer>Error with date range selection</NoDataContainer>;
    }
    if (!productSummary) {
      return <NoDataContainer>No products</NoDataContainer>;
    }

    switch (view) {
      case EView.LINE: {
        return (
          <LineGraphContainer>
            <MultiLineGraph
              productSummary={productSummary}
              periodStart={periodStart}
              periodEnd={periodEnd}
              pricePerUnitLabel={pricePerUnitLabel}
              dealName={dealName}
              selectedCostLabel={selectedCostFormulaLabel}
              selectedForecastLabel={selectedForecastLabel}
              productItemId={productItemId}
            />
          </LineGraphContainer>
        );
      }

      case EView.SURVIVAL: {
        return (
          <SurvivalPlot
            productSummary={productSummary}
            pricePerUnitLabel={pricePerUnitLabel}
            dealName={dealName}
            selectedCostLabel={selectedCostFormulaLabel}
            selectedForecastLabel={selectedForecastLabel}
            periodStart={periodStart}
            periodEnd={periodEnd}
            productItemId={productItemId}
          />
        );
      }

      case EView.BOX_PLOT: {
        return (
          <BoxPlot
            productSummary={productSummary}
            pricePerUnitLabel={pricePerUnitLabel}
            dealName={dealName}
            selectedCostLabel={selectedCostFormulaLabel}
            selectedForecastLabel={selectedForecastLabel}
            periodStart={periodStart}
            periodEnd={periodEnd}
            productItemId={productItemId}
          />
        );
      }

      default: {
        return <NoDataContainer>{messages.warnings.noData}</NoDataContainer>;
      }
    }
  }

  return (
    <Container>
      <Visual>{renderContent()}</Visual>
    </Container>
  );
};
